import common from "@/public/common";
import { ajaxApi, axiosPost } from "@/server/index";
import { getCookieNew } from "@/public/utils";

const accountHost = common.eurekaUrlDic; // escm-t.vsigo.cn/account
const providerHost = common.scsAccountProviderUrl + "scs-account-provider/"; // escm-t.vsigo.cn/scs-account-provider

// 获取所有菜单（与 main-page-layout.js 的 getMenus 保持一致）
export const getMenuApi = () => {
  return axiosPost(accountHost + "/permission/getmenu", {
    accountId: getCookieNew("accountId") ? parseInt(getCookieNew("accountId")) : null,
    roleType: "system_and_supplier",
    supplierCode: getCookieNew("supplier_code") || "",
    poSubjectCode: getCookieNew("po_subject_code") || "",
    supplierCompanyCode: getCookieNew("supplier_company_code") || "",
  });
};

// 更新菜单对应的名称和 url
// params: { id, menu_name, url }
export const updateMenuApi = (params) => {
  return ajaxApi({
    url: providerHost + "permission/updateMenu",
    params: { updateMenu: params },
  });
};



// WEBPACK FOOTER //
// ./src/pages/menuUpdate/service.js